<template>
  <!-- 订单处理-->
  <div class="orderProcessCol">
    <div class="orderProcessCol__top">
      <div class="left">
        <div class="bcWhite box-shadow">
          <el-tabs v-model="queryParams.status" class="bcWhite" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="新订单" name="1">
              <span slot="label">
                新订单<span v-show="countOrderMap[1] && countOrderMap[1] > 0" class="el-badge__content">{{ countOrderMap[1] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="异常订单" name="2">
              <span slot="label">
                异常订单<span v-show="countOrderMap[2] && countOrderMap[2] > 0" class="el-badge__content">{{ countOrderMap[2] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="催单" name="3">
              <span slot="label">
                催单<span v-show="countOrderMap[3] && countOrderMap[3] > 0" class="el-badge__content">{{ countOrderMap[3] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="配送异常" name="4">
              <span slot="label">
                配送异常<span v-show="countOrderMap[4] && countOrderMap[4] > 0" class="el-badge__content">{{ countOrderMap[4] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="取消/退款" name="5">
              <span slot="label">
                申请退款<span v-show="countOrderMap[5] && countOrderMap[5] > 0" class="el-badge__content">{{ countOrderMap[5] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="预订单" name="6">
              <span slot="label">
                预订单<span v-show="countOrderMap[6] && countOrderMap[6] > 0" class="el-badge__content">{{ countOrderMap[6] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="待抢单" name="7">
              <span slot="label">
                待抢单<span v-show="countOrderMap[7] && countOrderMap[7] > 0" class="el-badge__content">{{ countOrderMap[7] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="待取货" name="8">
              <span slot="label">
                待取货<span v-show="countOrderMap[8] && countOrderMap[8] > 0" class="el-badge__content">{{ countOrderMap[8] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="配送中" name="9">
              <span slot="label">
                配送中<span v-show="countOrderMap[9] && countOrderMap[9] > 0" class="el-badge__content">{{ countOrderMap[9] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="待处理" name="10">
              <span slot="label">
                待处理<span v-show="countOrderMap[10] && countOrderMap[10] > 0" class="el-badge__content">{{ countOrderMap[10] | dot }} </span>
              </span>
            </el-tab-pane>
            <el-tab-pane label="加单" name="12">
              <span slot="label">加单</span>
            </el-tab-pane>
            <el-tab-pane label="已完成" name="0">
              <span slot="label">已完成</span>
            </el-tab-pane>
            <el-tab-pane label="已取消" name="13">
              <span slot="label">已取消</span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="bcWhite box-shadow" style="margin-top: 10px">
          <el-select v-model="queryParams.cshop" class="marginRight10" filterable placeholder="全部门店" @change="changeListData" clearable>
            <el-option v-for="item in storeOptions" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
          </el-select>
          <el-select v-model="queryParams.platType" class="marginRight10" placeholder="全部渠道" @change="changeListData" clearable>
            <el-option label="美团" value="1" />
            <el-option label="饿了么" value="2" />
            <el-option label="京东" value="3" />
            <el-option label="小程序商城" value="4" />
          </el-select>
          <el-select ref="sortSelect" v-model="sortingValue" class="marginRight10" placeholder="排序方式"  @change="handleSelectSort" clearable>
            <el-option label="下单时间倒序" value="s_order_time-0"></el-option>
            <el-option label="下单时间正序" value="s_order_time-1"></el-option>
            <el-option label="抢单时间倒序" value="s_receive_time-0"></el-option>
            <el-option label="抢单时间正序" value="s_receive_time-1"></el-option>
            <el-option label="预计送达倒序" value="s_wish_time-0"></el-option>
            <el-option label="预计送达正序" value="s_wish_time-1"></el-option>
          </el-select>
          <el-input v-model="queryParams.search" class="w300 marginLeftAuto" placeholder="手机、姓名、地址、订单号、TOPS号" @keyup.enter.native="handleSelectSearch">
            <i slot="suffix" class="el-input__icon el-icon-search pointer" @click="handleSelectSearch"></i>
          </el-input>
          <el-button class="margin10" type="primary" size="mini" @click="openCreateOrderDialog">创建订单</el-button>
        </div>
      </div>
      <div class="right bcWhite box-shadow h100" style="min-width: 30%">
        <div v-if="queryParams.zFlow === '0'" style="background-color: rgb(235, 244, 246)" class="hHP flex directionColumn contentCenter">
          <div class="marginLeft20 marginBottom5">已完成</div>
          <div class="marginLeft20 fs20 fWB" style="color: rgb(0, 170, 48)">{{ countOrderMap[0] }}</div>
        </div>
        <div v-if="!(queryParams.zFlow === '0')" class="hHP marginTop10 marginLeft20">
          <el-row class="marginBottom5" style="height: 23px">
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '1' })">新订单</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[1] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '2' })">异常订单</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[2] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '3' })">催单</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[3] }}</div>
            </el-col>
          </el-row>
          <el-row class="marginBottom5 h20" style="height: 23px">
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '4' })">配送异常</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[4] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '5' })">申请退款</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[5] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '6' })">预订单</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[6] }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '7' })">待抢单</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[7] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '8' })">待取货</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[8] }}</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13 pointer" @click="handleTabClick({ name: '9' })">配送中</div>
            </el-col>
            <el-col :span="4">
              <div class="fs13">{{ countOrderMap[9] }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="orderProcessCol__body">
      <div class="body">
        <div class="body__left flex directionColumn">
          <div v-if="queryParams.zFlow === '1' || queryParams.zFlow === '6'" class="h50 marginBottom10 box-shadow bcWhite wHP flex alignItemsCenter paddingLeft20">
            <div>
              自动发单
              <el-switch v-model="autoSend" active-value="1" inactive-value="0" class="marginLeft20" @change="handleAutoSend" />
            </div>
            <div class="marginLeft20">
              <el-select v-model="orderFrequency" class="marginRight10" clearable filterable placeholder="请选择发单频次">
                <el-option label="每次20单" value="20"></el-option>
                <el-option label="每次30单" value="30"></el-option>
                <el-option label="每次50单" value="50"></el-option>
                <el-option label="每次100单" value="100"></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex1 scrollAuto scrollbar">
            <div class="hHP">
              <OrderList ref="orderList" class="hHP" @changeListInfoData="changeListInfoData" />
            </div>
          </div>
        </div>
        <div class="body__right">
          <OrderListInfo ref="orderListInfo" class="bcWhite box-shadow" @changeListData="changeListData" />
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="创建订单" :visible.sync="createOrderdialogVisible" width="1300px" style="top: -10vh;" append-to-body>
      <OrderCreateInfo v-if="createOrderdialogVisible" ref="orderInfo" @close-dialog="closeCreateOrderDialog" />
    </el-dialog>
  </div>
</template>

<script>
import OrderList from "@/views/order/orderList.vue";
import OrderListInfo from "@/views/order/orderListInfo.vue";
import OrderCreateInfo from "@/views/order/OrderCreateInfo.vue";
import { EventBus } from "@/store/event-bus";
export default {
  name: "OrderProcessing",
  components: {
    OrderListInfo,
    OrderList,
    OrderCreateInfo,
  },
  filters: {
    dot(num) {
      if (num < 100) {
        return num;
      } else {
        return "99+";
      }
    },
  },
  data() {
    return {
      //发单频次
      orderFrequency: "",
      autoSend: 0,
      deliverySetId: "",
      createOrderdialogVisible: false,
      queryParams: {
        status: "1",
      },
      status: "1",
      storeOptions: [],
      sortingValue: "s_order_time-0",
      //弹窗
      countOrderMap: [],
      orderId: null,
    };
  },
  mounted() {
    this.queryStore();
    this.getDeliverySettings();
    this.refreshPage();
    EventBus.$on("refreshPage", this.refreshPage);
  },
  beforeDestroy() {
    EventBus.$off("refreshPage");
  },
  methods: {
    openCreateOrderDialog() {
      this.createOrderdialogVisible = true;
    },
    closeCreateOrderDialog() {
      this.createOrderdialogVisible = false;
      this.refreshPage();
    },
    /**
     * 获取订单列表
     */
    changeListData() {
      this.$refs.orderList.changeListData(this.queryParams);
      this.countOrder();
    },
    changeListInfoData(sid) {
      this.$refs.orderListInfo.changeListInfoData(sid);
    },
    refreshPage(data) {
      if (data === undefined) {
        this.orderId = "";
        this.changeListData();
        return;
      }
      let json = JSON.parse(data);
      if (json.type === "notify") {
        this.orderId = "";
        this.changeListData();
      } else if (json.type === "callRing") {
        this.$confirm("您有新来电，是否应答并获取订单？")
          .then((_) => {
            this.topsAjax.get(`${this.baseUrls.websocket}/answer`, { userId: json.userId });
            this.$router.push({ path: "/order/orderInquiry", query: { orderId: json.orderId } });
          })
          .catch((_) => {});
      }
    },
    /**
     * 修改配送设置信息
     */
    handleAutoSend() {
      let params = {
        sid: this.deliverySetId,
        btimelyAutoSend: this.autoSend,
      };
      let url = `${this.baseUrls.deliverySettings}/update`;
      this.topsAjax.post(url, params).then((res) => {
        if (res === 1) {
          this.$message.success("操作成功！");
        } else {
          this.$message.error("操作失败！");
        }
      });
    },
    /**
     * 获取配送设置信息
     */
    getDeliverySettings() {
      let url = `${this.baseUrls.deliverySettings}/getData`;
      this.topsAjax.get(url, {}).then((res) => {
        this.autoSend = res.btimelyAutoSend;
        this.deliverySetId = res.sid;
      });
    },
    /**
     * 获取门店列表
     */
    queryStore() {
      this.storeOptions = [{ sid: null, cname: "全部" }];
      let url = `${this.baseUrls.orderShop}/queryList`;
      let params = {};
      this.topsAjax.get(url, params).then((res) => {
        this.storeOptions.push(...res);
      });
    },
    /**
     * 统计订单数
     */
    countOrder() {
      let url = `${this.baseUrls.third}/countOrder`;
      let params = {};
      this.topsAjax.get(url, params).then((res) => {
        this.countOrderMap = res;
      });
    },
    handleTabClick(tab) {
      if (tab.name === "7") {
        this.queryParams.field = "s_order_time";
        this.queryParams.isAsc = 1;
      } else if (tab.name === "8" || tab.name === "9") {
        this.queryParams.field = "s_receive_time";
        this.queryParams.isAsc = 1;
      } else if (tab.name === "1" || tab.name === "2" || tab.name === "3" || tab.name === "4" || tab.name === "6") {
        this.queryParams.field = "s_order_time";
        this.queryParams.isAsc = 1;
      } else if (tab.name === "5") {
        this.queryParams.field = "s_order_time";
        this.queryParams.isAsc = 0;
      } else {
        this.queryParams.field = "s_order_time";
        this.queryParams.isAsc = 0;
      }
      this.queryParams.status = tab.name;
      this.status = tab.name;
      this.changeListData();
    },
    handleSelectSort() {
      this.queryParams.field = this.sortingValue.split("-")[0];
      this.queryParams.isAsc = this.sortingValue.split("-")[1];
      this.changeListData();
    },
    handleSelectSearch() {
      this.$router.push({ path: "/order/orderInquiry", query: { orderId: this.queryParams.search } });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderProcessCol {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__top {
    padding: 3px;
    height: 100px;
    display: flex;
    margin-bottom: 10px;

    .left {
      height: 100%;
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      margin-right: 10px;
    }

    .right {
      height: 100%;
      min-width: 30%;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }
  }

  &__body {
    width: 100%;
    flex: 1;
    overflow: hidden;

    .body {
      padding: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 100%;

      &__left {
        //overflow: auto;
        flex: 1;
        margin-right: 10px;
      }

      &__right {
        width: 30%;
        height: 100%;

        & > div {
          height: 100%;
          flex: 1;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.orderProcessCol {
  .el-tabs__item.is-active {
    text-decoration: underline;
  }

  .el-tabs__item {
    padding: 0 10px;
  }

  .el-input__inner {
    border: 0;
  }
}
</style>
